import {Stack, Text, useViewport} from '@treatwell/ui';
import {PageContainer} from '../../PageContainer';
import {Form} from './Form';
import styles from './LoginPage.module.css';

export const LoginPage = () => {
  const isMobile = useViewport({device: ['mobile', 'tablet']});

  return (
    <PageContainer>
      <Stack space="lg" className={styles.root}>
        <Text type={isMobile ? 'xlHeader' : 'heading2'} as="h1">
          Log in to Treatwell
        </Text>
        <Form />
      </Stack>
    </PageContainer>
  );
};
